import { cta1 } from '../../utils/icons';

import { registerBlockType } from '@wordpress/blocks';
import { __ } from '@wordpress/i18n';

import './style.scss';
import Edit from './edit';
import save from './save';
import deprecated from './deprecated';

registerBlockType('asl/cta-1', {
	icon: cta1,
	description: __(
		'The Call To Action block helps you to create attractive call-to-action with a trendy title, description and a catchy button that boosts conversions on your website.'
	),
	example: {
		attributes: {
			title: 'Title Block',
			alignment: 'center',
			image: 'https://via.placeholder.com/640x140',
			borderColor: '#332e54',
			borderWidth: '2',
			borderRadius: '5',
			btnText1: 'Button 1',
			btnText2: 'Button 2',
		},
		innerBlocks: [
			{
				name: 'core/image',
				attributes: {
					src: 'https://s.w.org/images/core/5.3/Biologia_Centrali-Americana_-_Cantorchilus_semibadius_1902.jpg',
				},
			},
		],
	},
	attributes: {
		title: {
			type: 'string',
			source: 'html',
			selector: 'h3',
		},
		body: {
			type: 'array',
			source: 'children',
			selector: '.asl-cta-1-content',
		},
		alignment: {
			type: 'string',
			default: 'none',
		},
		image: {
			type: 'string',
			default: 'https://via.placeholder.com/640x140',
		},
		borderColor: {
			type: 'string',
			default: '#332e54',
		},
		borderWidth: {
			type: 'number',
			default: 6,
		},
		borderRadius: {
			type: 'number',
			default: 5,
		},
		btnText1: {
			type: 'string',
			default: '',
			source: 'html',
			selector: '.asl-btn-first',
		},
		btnText2: {
			type: 'string',
			default: '',
			source: 'html',
			selector: '.asl-btn-second',
		},
		btnStyleFirst: {
			type: 'string',
			default: 'outline',
		},
		btnStyleSecond: {
			type: 'string',
			default: 'fill',
		},
		btnBackgroundFirst: {
			type: 'string',
			default: '',
		},
		btnBackgroundSecond: {
			type: 'string',
			default: '',
		},
		btnHoverBackgroundFirst: {
			type: 'string',
		},
		btnHoverBackgroundSecond: {
			type: 'string',
		},
		btnColorFirst: {
			type: 'string',
			default: '',
		},
		btnColorSecond: {
			type: 'string',
			default: '',
		},
		btnHoverColorFirst: {
			type: 'string',
		},
		btnHoverColorSecond: {
			type: 'string',
		},
		borderRadiusFirst: {
			type: 'number',
			default: 1,
		},
		borderRadiusSecond: {
			type: 'number',
			default: 0,
		},
		borderWidthFirst: {
			type: 'number',
			default: 2,
		},
		borderWidthSecond: {
			type: 'number',
			default: 2,
		},
		btnBorderColorFirst: {
			type: 'string',
			default: '',
		},
		btnBorderColorSecond: {
			type: 'string',
			default: '',
		},
		btnLinkFirst: {
			type: 'string',
			source: 'attribute',
			selector: '.asl-btn-first',
			attribute: 'href',
		},
		btnLinkSecond: {
			type: 'string',
			source: 'attribute',
			selector: '.asl-btn-second',
			attribute: 'href',
		},
		rel: {
			type: 'string',
			source: 'attribute',
			selector: 'a',
			attribute: 'rel',
			default: 'sponsored nofollow',
		},
		target: {
			type: 'boolean',
			default: true,
		},
	},
	edit: Edit,
	save,
	deprecated,
});
